@if(!isClaimCreditPage) {
<h2 class="m-0" [ngClass]="isReviewPage ? 'pt-4' : 'pb-4'">Contact information</h2>
<p *ngIf="isReviewPage" class="line-height-3 py-2 m-0">By providing your contact info, you authorize us to reach you
    about this request and your coverage.</p>
}

<div *ngIf="messagesAvailable && !isReviewPage" class="w-full flex align-items-center justify-content-center">
    <ng-container *ngIf="messages && messages.length">
        <p-message
            *ngFor="let msg of messages; let i = index; trackBy: trackByIndex"
            [severity]="msg.severity"
            [text]="msg.text"
            class="w-full flex justify-content-center"
            styleClass="w-full pt-3 pb-3"
        ></p-message>
    </ng-container>
</div>

<ng-container *ngIf="!isClaimCreditPage; else plainTemplate">
    <p-card *ngIf="editMode">
        <div class="numbers-container">
            <div class="flex">
                <p class="font-medium m-0 sm:text-sm md:text-base">Phone Numbers</p>
                <p class="ml-2 mb-0 text-xs mt-0 bg-slate-100 p-1 required">Required</p>
            </div>
            <p [ngClass]="anyContactNumberPresent() ? 'text-slate-600' : 'text-rose-600'">{{phoneNumbersReq}}</p>
        </div>
        <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
    </p-card>
</ng-container>
<ng-template #plainTemplate>
    <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
</ng-template>
<p-card styleClass="h-full" *ngIf="!editMode && !isClaimCreditPage && isReviewPage">
    <div class="phoneList">
        <div *ngIf="(phoneList && phoneList.length > 0)">
            <p class="custom-bold m-0"> <i class="pi pi-phone mr-1"></i> Phone
                numbers</p>
            <div *ngFor="let phone of phoneList; let i = index; trackBy: trackByIndex" class="my-2">
                <span *ngIf="phone.phoneType" [innerHTML]="formatPhone(phone.phoneType)"></span>&nbsp;
                <span *ngIf="phone.phoneType && phone.phoneNumber" [innerHTML]="phone.phoneNumber | phone:true" appGaButtonClick
                    [buttonLocation]="contactInfoPageLocation" [buttonName]="setButtonName(phone.phoneType)"></span>
            </div>
        </div>
    </div>
    <div class="flex flex-column">
        <p class="custom-bold my-2"> <i class="pi pi-envelope mr-1"></i>Email</p>
        <span class="text-heading mb-3">{{primaryEmail}}</span>
    </div>
    <p-button [link]="true" label="Edit" severity="primary" styleClass="underline white-space-nowrap pl-0"
        data-auto-id="edit-button" (click)="editContactInformation(true)">
    </p-button>
</p-card>

<ng-template #formTemplate>
    <form [formGroup]="contactInformationForm">
        <div class="numbers-container" *ngIf="!isClaimCreditPage">
            <div class="flex grid justify-content-between">
                <p class="text-sm px-0 col-2">Phone</p>
                <p class="text-sm col-7"></p>
                <p class="text-sm pl-0 pr-1 sm:pr-2 xl:pr-3 text-right col-3">Preferred</p>
            </div>
            <div *ngFor="let type of contactTypes; let i = index; trackBy: trackByIndex"
                class="input-container mb-3 flex grid align-items-baseline justify-content-between p-fieldset field">
                <label [attr.for]="'phoneValue' + type.value" class="text-sm m-0 p-0 col-2">{{type.label}}</label>
                <div class="col-8 pr-0">
                    <input pInputText type="text" 
                    class="text-sm w-full"
                    [ngClass]="highlightInput ? 'highlightBorder' : ''"
                    [attr.id]="'phoneValue'+type.value"
                    [attr.data-auto-id]="'phoneValue'+type.value" [formControlName]="'phoneValue'+type.value"
                    pSize="large"
                    pattern="^[0-9]*$"
                    inputmode="numeric"
                    (input)="sanitizeFormControl($event, 'phoneValue' + type.value)"
                    />
                    <p class="m-0 text-rose-600" *ngIf="contactInformationForm.get('phoneValue' + type.value)?.invalid && contactInformationForm.get('phoneValue' + type.value)?.touched">Please enter a valid phone number.</p>
                </div>
                <p-radiobutton class="text-sm text-center col-2" formControlName="preferred" [value]="type.value"
                    [attr.data-auto-id]="'radio'+type.value"
                    [ngClass]="highlightInput ? 'highlightRadioBtn' : ''" 
                    [ariaLabel]="'Set ' + type.label + ' as preferred phone number'" />
            </div>
        </div>
        <p-divider class="mt-4" *ngIf="!isClaimCreditPage" />
        <div class="email-container mt-4">
            <app-shared-input [control]="contactInformationForm.controls['email']" [highlightOnError]="highlightInput"  label="Email address"
                dataAutoId="edit-contact-email-input" [isEmailInput]="true">
            </app-shared-input>
        </div>
        <div [ngClass]="isReviewPage ? 'flex flex-row-reverse justify-content-between gap-4' : 'flex-1'">
            <div class="p-0" [ngClass]="isReviewPage ? 'flex-1' : 'col-12'">
                <p-button label="Save" [disabled]="contactInformationForm.invalid || isLoading" rounded="true"
                    severity="primary" data-auto-id="edit-contact-information-save-button"
                    styleClass="text-$white  text-sm w-full ml-0" (click)="checkForValidMobileNumber()"
                    [loading]="isLoading" />
            </div>
            <div class="p-0" [ngClass]="isReviewPage ? 'flex-1' : 'col-12 mt-3'" *ngIf="!isClaimCreditPage && !hideCancel">
                <p-button label="{{isReviewPage ? 'Cancel' : 'Back'}}"
                    [disabled]="isLoading" rounded="true" severity="secondary"
                    data-auto-id="edit-contact-information-navigate-button"
                    styleClass="text-slate-800 shadow-button text-sm w-full ml-0" (click)="navigateBack()" />
            </div>
        </div>
    </form>
</ng-template>